import { xor } from "lodash-es";

export const toggleItemInArray = <T extends any | number>(array: T[], item: T) =>
  !!item || item == 0 ? xor(array, [item]) : array;
